export enum AiAgentSocketEvent {
  /* frontend -> backend */
  AI_QUERY = 'ai_query',
  AI_QUERY_SENT = 'ai_query_sent',
  AI_QUERY_ERROR = 'ai_query_error',
  JOIN_SESSION = 'join_session',
  LEAVE_SESSION = 'leave_session',
  /* backend -> frontend */
  AI_AGENT_CHAT_RESPONSE = 'AI_AGENT_CHAT_RESPONSE',
  AI_AGENT_FILTER_RESPONSE = 'AI_AGENT_FILTER_RESPONSE',
  AI_AGENT_ERROR = 'AI_AGENT_ERROR',
  AI_AGENT_RESPONSE = 'AI_AGENT_RESPONSE',
}

export enum AiAgentResponseStatusEnum {
  success = 'success',
  error = 'error',
  timeout = 'timeout'
}

export enum AiAgentMessageRoleEnum {
  user = 'user',
  assistant = 'assistant',
}
